// extracted by mini-css-extract-plugin
module.exports = {"mark":"mark--9QH97","selected":"selected--sfWdQ","highlighted":"highlighted--LwFqa","relation":"relation--oijJh","delete":"delete--Sr0fU","row":"row--FlFRa"};